module.exports = __webpack_public_path__ + "img/foto_giliani.23b407de.png";